import React, { useState, useEffect } from "react";

const Recordatorio = (props) => {
  const [fechaRecordatorio, setFechaRecordatorio] = useState("");
  const [horaRecordatorio, setHoraRecordatorio] = useState("");
  const [asunto, setAsunto] = useState("");
  const [recordatoriosLocales, setRecordatoriosLocales] = useState([]);

  /**
   * Función para agregar un recordatorio.
   */
  const crearRecordatorioHandler = (event) => {
    event.preventDefault();
    
    if (!fechaRecordatorio || !horaRecordatorio || !asunto) {
      alert("Por favor complete todos los campos");
      return;
    }

    const fechaCompleta = new Date(`${fechaRecordatorio}T${horaRecordatorio}`);
    const ahora = new Date();
    
    if (fechaCompleta <= ahora) {
      alert("La fecha y hora del recordatorio debe ser futura");
      return;
    }

    let elemento = {
      idMovimiento: props.movimiento.id,
      minutos: Math.ceil((fechaCompleta - ahora) / 60000), // Convertir a minutos para compatibilidad
      fechaRecordatorio: fechaCompleta,
      creacion: ahora,
      asunto: asunto,
      idUsuario: props.usuario,
      idPlataforma: props.movimiento.plataforma? props.movimiento.plataforma.id : props.movimiento.idPlataforma.id,
      placa: props.movimiento.placa,
      cartaPorte: props.movimiento.cartaPorte,
      idCorredor: props.movimiento.corredor? props.movimiento.corredor.id : props.movimiento.idCorredor.id
    };

    props.addToArray(elemento);
    
    setRecordatoriosLocales((prev) => [
      ...prev,
      <li className="list-group-item list-group-item-success border-left-success" key={`${elemento.idMovimiento}-${Date.now()}`}>
        <div>
          <h6 className="mb-1">
            <i className="fa fa-truck mr-2"></i>
            Movimiento: {elemento.idMovimiento}
          </h6>
          <p className="mb-1">
            <i className="fa fa-clock-o mr-2"></i>
            <strong>Recordatorio:</strong> {fechaCompleta.toLocaleString('es-ES')}
          </p>
          <p className="mb-1">
            <i className="fa fa-comment mr-2"></i>
            <strong>Motivo:</strong> {elemento.asunto}
          </p>
        </div>
      </li>
    ]);

    // Limpiar formulario
    setFechaRecordatorio("");
    setHoraRecordatorio("");
    setAsunto("");
  };

  /**
   * Función para abrir GPS (mantiene la funcionalidad original)
   */
  const abrirGPS = (recordatorio) => {
    // Integración con la funcionalidad GPS existente del panel
    if (props.abrirmodalGps) {
      props.abrirmodalGps();
    } else {
      // Fallback: mostrar información del movimiento
      alert(`Recordatorio para movimiento ${recordatorio.idMovimiento}\nMotivo: ${recordatorio.asunto}`);
    }
  };

  /**
   * Función para verificar recordatorios vencidos
   */
  const verificarRecordatorios = () => {
    const ahora = new Date();
    if (props.tiempos) {
      props.tiempos.forEach(tiempo => {
        if (tiempo.fechaRecordatorio && new Date(tiempo.fechaRecordatorio) <= ahora) {
          // Mostrar alerta del recordatorio
          if (window.confirm(`Recordatorio: ${tiempo.asunto}\n¿Desea ver el GPS del movimiento ${tiempo.idMovimiento}?`)) {
            abrirGPS(tiempo);
          }
        }
      });
    }
  };

  /**
   * Preparar recordatorios existentes
   */
  useEffect(() => {
    if (props.tiempos) {
      setRecordatoriosLocales(
        props.tiempos.map((tiempo) => {
          const fechaRecordatorio = new Date(tiempo.fechaRecordatorio || tiempo.creacion);
          const ahora = new Date();
          const esPasado = fechaRecordatorio <= ahora;
          
          return (
            <li 
              className={`list-group-item ${esPasado ? 'list-group-item-warning' : 'list-group-item-info'}`} 
              key={tiempo.idMovimiento}
            >
              <p><strong>Movimiento:</strong> {tiempo.idMovimiento}</p>
              <p><strong>Recordatorio:</strong> {fechaRecordatorio.toLocaleString()}</p>
              <p><strong>Estado:</strong> {esPasado ? 'Vencido' : 'Pendiente'}</p>
              <p><strong>Asunto:</strong> {tiempo.asunto}</p>
            </li>
          );
        })
      );
    }

    // Verificar recordatorios cada minuto
    const interval = setInterval(verificarRecordatorios, 60000);
    return () => clearInterval(interval);
  }, [props.tiempos]);

  // Obtener fecha mínima (hoy) en zona horaria local
  const hoy = new Date();
  const year = hoy.getFullYear();
  const month = String(hoy.getMonth() + 1).padStart(2, '0');
  const day = String(hoy.getDate()).padStart(2, '0');
  const fechaMinima = `${year}-${month}-${day}`;
  
  console.log("Fecha mínima calculada:", fechaMinima);

  return (
    <>
      <form>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <h5 className="text-center mb-3">Programar Recordatorio</h5>
            <small className="form-text text-muted text-center d-block mb-3">
              Seleccione una fecha y hora futura para recibir un recordatorio con acceso al GPS del movimiento.
            </small>
            
            <div className="form-group mb-3">
              <label htmlFor="fechaRecordatorio">
                Fecha del Recordatorio <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="fechaRecordatorio"
                value={fechaRecordatorio}
                min={fechaMinima}
                onChange={(e) => setFechaRecordatorio(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="horaRecordatorio">
                Hora del Recordatorio <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="time"
                className="form-control"
                id="horaRecordatorio"
                value={horaRecordatorio}
                onChange={(e) => setHoraRecordatorio(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="asunto">
                Motivo del Recordatorio <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                className="form-control"
                id="asunto"
                rows="3"
                value={asunto}
                placeholder="Ej: Verificar llegada a destino, Revisar documentación, etc."
                onChange={(e) => setAsunto(e.target.value)}
              />
            </div>

            <div className="text-center mb-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={crearRecordatorioHandler}
                disabled={!fechaRecordatorio || !horaRecordatorio || !asunto}
              >
                <i className="fa fa-calendar-plus-o mr-2"></i>
                Crear Recordatorio
              </button>
            </div>
          </div>
        </div>

        {recordatoriosLocales.length > 0 && (
          <div className="row justify-content-center">
            <div className="col-md-10">
              <h6>Recordatorios:</h6>
              <ul className="list-group">{recordatoriosLocales}</ul>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default Recordatorio;
